
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { ModalNext, ModalHeader, ModalBody, ModalFooter } from '@jutro/components';
import _ from 'lodash';

import metadata from './MLTransactionDiffPopup.metadata.json5'
import messages from '../MLSummary.messages'
import styles from '../MLSummary.module.scss'

import { Button } from '@jutro/legacy/components';

function MLTransactionDiffPopup(props) {
    const {
        data,
        isOpen,
        onSaveAction,
        onReject,
        onResolve
    } = props;
    const translator = useTranslator();
    const [didUpdate, setDidUpdate] = useState(false);
    
    const handleClose = useCallback(() => {
        data.transaction1 = undefined;
        data.transaction2 = undefined;
        data.transactionList2 = [];
        onReject();
    }, [onReject]);

    const handleSave = useCallback(
        () => {
            if (onSaveAction && !onSaveAction(data)) {
                return;
            }
            onResolve(data);
        },[data, onResolve, onSaveAction]
    );
    
    if (!isOpen) {
        return null;
    };

    const mapAvailableValues = (values) => {
        return values.map((type) => {
            return {
                code: type.jobNumber,
                name: translator({
                    id: type.name,
                    defaultMessage: type.name
                })
            };
        });
    };

    const transaction1ValueChange = (newValue) => {
        if (newValue === undefined) {
            data.transaction1 = undefined;
            data.transaction2 = undefined;
            data.transactionList2 = [];
        } else if (data.transaction1 === undefined || newValue !== data.transaction1.jobNumber) {
            data.transaction1 = data.transactionList1.find((t) => t.jobNumber === newValue);
            data.transactionList2 = data.transactionList1.filter((t) => t.jobNumber !== newValue);
        } else {
            data.transaction2 = undefined;
            data.transactionList2 = [];
        }
        setDidUpdate(!didUpdate);
    }

    const transaction2ValueChange = (newValue) => {
        if (newValue !== undefined) {
            data.transaction2 = data.transactionList2.find((t) => t.jobNumber === newValue);
        } else {
            data.transaction2 = newValue;
        }
        setDidUpdate(!didUpdate);
    }

    const overrideProps = {
        transactionSelect1: {
            availableValues: mapAvailableValues(data.transactionList1),
            onValueChange: (value1) => transaction1ValueChange(value1),
            value: (data.transaction1)? data.transaction1.jobNumber : null
        },
        transactionSelect2: {
            availableValues: mapAvailableValues(data.transactionList2),
            disabled: data.transactionList2.length === 0,
            onValueChange: (value1) => transaction2ValueChange(value1),
            value: (data.transaction2)? data.transaction2.jobNumber : null
        }
    };
    
    return (
        <ModalNext
            className={styles['ml-modal-dialog']}
            isOpen={isOpen}
            onRequestClose={handleClose}
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEsc={false}
        >
            <ModalHeader
                title={messages.TransactionDiffPopupTitle}
                onClose={handleClose}
                contentLayout={{
                    component: 'div',
                    componentProps: {
                        className: styles['modal-header']
                    }
                }}
                titleLayout={{
                    component: 'flex',
                    componentProps: {
                        direction: "column",
                        className: styles['modal-title']
                    }
                }}
            />
            <ModalBody contentLayout={{
                component: 'div',
                componentProps: {
                    className: styles['modal-body']
                }
            }}
            >
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={data}
                    overrideProps={overrideProps}
                />
            </ModalBody>
            <ModalFooter contentLayout={{
                component: 'flex',
                componentProps: {
                    className: styles['modal-footer']
                }
            }}
            >
                <Button id="actionButton" onClick={handleSave} type="filled" disabled={!data.transaction1 || !data.transaction2}>
                    { translator(messages.Compare) }
                </Button> 
                <Button id="cancelActionButton" onClick={handleClose} type="outlined">
                    { translator(messages.Cancel) }
                </Button>
            </ModalFooter>
        </ModalNext>
    );

}

MLTransactionDiffPopup.propTypes = {
    props: PropTypes.shape({
        data: PropTypes.shape([]),
        isOpen: PropTypes.bool,
        onSaveAction: PropTypes.func,
        onResolve: PropTypes.func,
        onReject: PropTypes.func
    })
};
MLTransactionDiffPopup.defaultProps = {
    props: {
        data: [],
        isOpen: false,
        onSaveAction: _.noop,
        onResolve: _.noop,
        onReject: _.noop
    }
};
export default MLTransactionDiffPopup;
